export const ru = {
    'center-bottom': 'Центр низ',
    'center-center': 'Центр центр',
    'center-top': 'Центр верх',
    default: '-',
    'left-bottom': 'Лево низ',
    'left-center': 'Лево центр',
    'left-top': 'Лево верх',
    'right-bottom': 'Право низ',
    'right-center': 'Право центр',
    'right-top': 'Право верх'
};
